
// 指标库审核状态
export const kpiAuditStates = [ '草稿', '待审核', '审核中', '退回重审', '审核不通过', '审核通过' ];

export const kpiAuditStateOptions = kpiAuditStates.map((s, idx) => {
    return { value: idx, label: s };
});

// 指标库发布状态
export const kpiPublishStates = [ '预留', '未发布', '下架', '已发布' ];

export const kpiPublishStateOptions = kpiPublishStates.map((s, idx) => {
    return { value: idx, label: s };
});

export const kpiCompareModeTexts = [ '未设置', '不使用', '定性', '=', '!=', '>', '>=', '<', '<=' ];

export const getKpiCompareModeText = (mode) => {
    return kpiCompareModeTexts[mode] || '';
};
